<template>
  <div class="w-100">
    Appointment CANCELLED
    <appointment-object :appointment-number="appointmentNumber()" />
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
